module.exports = __webpack_public_path__ + "static/media/Foodtopia_mobile.493c2e7c.jpg";